import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { SettoreDTO } from "../settoreDTO";
import { DocumentoDTO } from "../documentoDTO";
import { MetadatiProtocolloGescorDTO } from "./metadati-protocollo-gescorDTO";
import { DestinatarioDTO } from "./destinatarioDTO";
import { DestinatarioInternoDTO } from "./destinatario-internoDTO";
import { DestinatarioDipendenteDTO } from "./destinatario-dipendenteDTO";
import { ClassificaDTO } from "../classificaDTO";
import { UtenteDTO } from "../utenteDTO";
import { ClassificaGescorDTO } from "./classifica-gescorDTO";
import { DatiFirmaDTO } from "../dati-firmaDTO";
import { DocumentoGescorDTO } from "./documeto-gescorDTO";

export class CreaCorrispondenzaPartenzaDTO {

    idUnitaDocumentaria: string;

    destinatari: DestinatarioDTO[];

    destinatariCartacei: DestinatarioDTO[];

    destinatariInterni: DestinatarioInternoDTO[];

    destinatariDipendenti: DestinatarioDipendenteDTO[];

    firmatario: UtenteDTO;

    settoreFirmatario: SettoreDTO;

    tipoProtocollo: TipoProtocolloEnum;

    mittente: SettoreDTO;

    oggetto: string;

    riservata: boolean;

    primario: DocumentoGescorDTO;

    allegati: DocumentoGescorDTO[];





}